var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKanalabsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M561.778 227.555C561.778 217.082 553.279 208.53 542.827 209.19C509.777 211.274 477.251 218.801 446.576 231.508C410.052 246.636 376.866 268.81 348.912 296.764C320.959 324.718 298.784 357.904 283.656 394.428C268.527 430.951 260.741 470.097 260.741 509.63C260.741 549.162 268.527 588.308 283.656 624.831C298.784 661.355 320.959 694.541 348.912 722.495C376.866 750.449 410.052 772.623 446.576 787.751C477.251 800.458 509.777 807.985 542.827 810.069C553.279 810.729 561.778 802.177 561.778 791.704L561.778 227.555Z",
    fill: "url(#paint0_linear_121_4746)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M722.963 289.185C722.963 278.712 714.457 270.141 704.02 271.003C648.717 275.57 596.55 300.023 557.029 340.343C513.02 385.241 488.296 446.135 488.296 509.63C488.296 573.124 513.02 634.019 557.029 678.916C596.55 719.236 648.717 743.689 704.02 748.256C714.457 749.118 722.963 740.547 722.963 730.074V289.185Z",
    fill: "url(#paint1_linear_121_4746)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_4746",
    x1: 257.09,
    y1: 873.932,
    x2: 728.217,
    y2: 133.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0194FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FF8D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_4746",
    x1: 485.451,
    y1: 799.018,
    x2: 862.642,
    y2: 217.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0194FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FF8D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanalabsIcon);
export default __webpack_public_path__ + "static/media/kanalabs-icon.e6657d50252e3560028262e3c44cda2a.svg";
export { ForwardRef as ReactComponent };